/**
 * @msg 设置公共头
 * @return {*}
 */
let setCount = 0
let setId: any = null
export const setCommonHead = (str = 'header,footer') => {
  if (window.__HGJ_PH_CONFIG__?.initialized) {
    // 隐藏公共头、页尾部分
    // window.__HGJ_PH_CONFIG__.exclude = 'header,footer'
    // 或使用set方法
    // console.log('设置公共头')

    window.__HGJ_PH_CONFIG__.set('exclude', str)
  } else {
    setCount++
    if (setCount >= 8) {
      clearTimeout(setId)
      setCount = 0
      return
    }
    setId = setTimeout(() => {
      setCommonHead(str)
    }, 1000)
  }
}
